import LayoutContainer from "./LayoutContainer";
import LayoutStore from "./LayoutStore";

export default LayoutStore(LayoutContainer);